import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as profitLossService from '../services/profitLossService'
import * as userService from '../services/userService'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import Autocomplete from 'react-autocomplete';
import Currency from './sub_components/currency'
import Toast from './sub_components/toast';
import * as userUtil from '../util/user.util';
import { BASE_IMAGE_PATH, BASE_IMAGE_PATH_NEW } from '../configs/api';
import { CSVLink } from 'react-csv';
import * as _ from 'lodash';





class SportsRevenue extends Component {
   csvLink = React.createRef();
   constructor(props) {
      super(props);
      this.state = {
         mySharingUserMappedList:{},
         totalpnl: 0, 
         totalcommission: 0,
         totalnew: 0,
         from: "",
         to: "",
         accounts: "",
         client_id: "",
         usersList: [],
         currUserData: {},
         toastMsg: "",
         toastType: "",
         showToast: false,
         showData: false,
         loader: false,
         isMySharingUserMappedList: false,

         searchText: "",
         pageLimit: 25,
         pageActive: 1,
         csv_json: [],
         page_no: 1, 
         shortField: "USER",
         shortType: "asc",
         user_list:[],
         
      
      };
   }
   componentDidMount() {
      let userData = localStorage.getItem("tokenData")
      userData = JSON.parse(userData)
      if(!(!!userData && !!userData.sub)){
         localStorage.clear();
         this.props.history.push("/auth")
      }
      let currUserData = localStorage.getItem("userAccData")
      currUserData = JSON.parse(currUserData)
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ accounts: userData.sub, to: curDate, from: weekDate, currUserData: currUserData })
   }
   parseToPickerDate(date) {
      let dtArr = date.split("/")
      let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
      return dt
   }
   parseFilterBody() {
      let body = {
         "userId": this.state.client_id,
         "from": new Date(this.state.from).toISOString(),
         "to": new Date(this.state.to).toISOString(),
     }
      body = this.clean(body);
      return body
   }
   async submitForm() {
      const self = this;
      let body = this.parseFilterBody()
      this.setState({ loader: true, totalnew: 0 })
      await profitLossService.postSportsRevenue(body).then((res) => {

         let mySharingUserMappedList = {};
         // let pnl_newdata={
         //    "USER":"",
         //    "PARENT":"",
         //    "ODDS_4":{et:"4", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0},
         //    "BOOKMAKER_4":{et:"4", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
         //    "FANCY_4":{et:"4", mt:"FANCY", bt:"LINE", pnl: 0},
         //    "LINE_4":{et:"4", mt:"LINE", bt:"LINE", pnl: 0},
         //    "TOTALCOM_4":{et:"4", commission: 0},
         //    "TOTAL_4":{et:"4", total: 0},
         //    "ODDS_1":{et:"1", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0},
         //    "BOOKMAKER_1":{et:"1", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
         //    "OVER_UNDER_1":{et:"1", mt:"OVER_UNDER", bt:"ODDS", pnl: 0},
         //    "TOTALCOM_1":{et:"1", commission: 0},
         //    "TOTAL_1":{et:"1", total: 0},
         //    "ODDS_2":{et:"2", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0},
         //    "BOOKMAKER_2":{et:"2", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
         //    "TOTALCOM_2":{et:"2", commission: 0},
         //    "TOTAL_2":{et:"2", total: 0},
         //    "WIN_7":{et:"7", mt:"WIN", bt:"ODDS", pnl: 0},            
         //    "TOTALCOM_7":{et:"7", commission: 0},
         //    "TOTAL_7":{et:"7", total: 0},
         //    "WIN_4339":{et:"4339", mt:"WIN", bt:"ODDS", pnl: 0},
         //    "TOTALCOM_4339":{et:"4339", commission: 0},
         //    "TOTAL_4339":{et:"4339", total: 0},
         //    "BOOKMAKER_400":{et:"400", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
         //    "TOTAL_400":{et:"400", total: 0},
         //    "BOOKMAKER_500":{et:"500", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
         //    "FANCY_500":{et:"500", mt:"FANCY", bt:"LINE", pnl: 0},
         //    "TOTAL_500":{et:"500", total: 0},
         //    "DAILY_300":{et:"300", mt:"DAILY", bt:"LINE", pnl: 0},
         //    "1_HOUR_300":{et:"300", mt:"1_HOUR", bt:"LINE", pnl: 0},
         //    "2_HOUR_300":{et:"300", mt:"2_HOUR", bt:"LINE", pnl: 0},
         //    "TOTAL_300":{et:"300", total: 0},
         //    "TOTAL_PNL": 0,
         //    "MYSHARE": 0,
         //    "SHARINGPERCENT": 0
         // }

         
         // "OVER_UNDER_35_1":{et:"1", mt:"OVER_UNDER_35", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
         // "OVER_UNDER_25_1":{et:"1", mt:"OVER_UNDER_25", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
         // "OVER_UNDER_15_1":{et:"1", mt:"OVER_UNDER_15", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},
         // "OVER_UNDER_05_1":{et:"1", mt:"OVER_UNDER_05", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0},

         // pnl_newdata["DIGITAIN_999"] = {et:"999", mt:"SPORTBOOK", bt:"ODDS", pnl: 0, commission: 0, pnl_commission: 0};

         if (res.isSuccess) {

            const userSharingDic = Object.assign({}, ...res.userSharing.map((x) => ({[x.username]: {role:x.role, sharing_detail_sports: x.sharing_detail.sports}})));
            for(const usr of res.items)
            {
               if(!(!!mySharingUserMappedList[usr._id.username])){
                  const prnt = usr._id.parents ? userUtil.getAppropriateParent(usr._id.parents, this.state.accounts): "";
                  mySharingUserMappedList[usr._id.username] = {
                     "USER": usr._id.username,
                     "PARENT": prnt,
                     "PARENTROLE": prnt !== '' ? (prnt === this.state.currUserData.username ? this.state.currUserData.role : (userSharingDic[prnt === this.state.accounts ? usr._id.username : prnt].role)) : '',
                     "ODDS_4":{et:"4", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0},
                     "BOOKMAKER_4":{et:"4", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
                     "FANCY_4":{et:"4", mt:"FANCY", bt:"LINE", pnl: 0},
                     "LINE_4":{et:"4", mt:"LINE", bt:"LINE", pnl: 0},
                     "WINNING_ODDS_4":{et:"4", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0},
                     "TOTALCOM_4":{et:"4", commission: 0},
                     "TOTAL_4":{et:"4", total: 0, bets: 0},
                     "ODDS_1":{et:"1", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0},
                     "BOOKMAKER_1":{et:"1", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
                     "OVER_UNDER_1":{et:"1", mt:"OVER_UNDER", bt:"ODDS", pnl: 0},
                     "WINNING_ODDS_1":{et:"1", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0},
                     "TOTALCOM_1":{et:"1", commission: 0},
                     "TOTAL_1":{et:"1", total: 0, bets: 0},
                     "ODDS_2":{et:"2", mt:"MATCH_ODDS", bt:"ODDS", pnl: 0},
                     "BOOKMAKER_2":{et:"2", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
                     "WINNING_ODDS_2":{et:"2", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0},
                     "TOTALCOM_2":{et:"2", commission: 0},
                     "TOTAL_2":{et:"2", total: 0, bets: 0},
                     "ODDS_7":{et:"7", mt:"WIN", bt:"ODDS", pnl: 0},            
                     "TOTALCOM_7":{et:"7", commission: 0},
                     "TOTAL_7":{et:"7", total: 0, bets: 0},
                     "ODDS_4339":{et:"4339", mt:"WIN", bt:"ODDS", pnl: 0},
                     "TOTALCOM_4339":{et:"4339", commission: 0},
                     "TOTAL_4339":{et:"4339", total: 0, bets: 0},
                     "BOOKMAKER_400":{et:"400", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
                     "FANCY_400":{et:"400", mt:"BOOKMAKER", bt:"BOOKMAKER", pnl: 0},
                     "WINNING_ODDS_400":{et:"400", mt:"WINNING_ODDS", bt:"ODDS", pnl: 0},
                     "TOTAL_400":{et:"400", total: 0, bets: 0},
                     "TOTAL_PNL": 0,
                     "MYSHARE": 0,
                     "SHARINGPERCENT": prnt !== '' ? userSharingDic[prnt === this.state.accounts ? usr._id.username : prnt].sharing_detail_sports : 0
                  };
               }
               mySharingUserMappedList[usr._id.username][(usr._id.bt === "LINE" ? `${usr._id.provider === "BETFAIR" ? "LINE" : "FANCY"}_${usr._id.et}` : `${usr._id.et === '1' && usr._id.mt.includes('OVER_UNDER') ? 'OVER_UNDER' : (usr._id.mt === "WINNING_ODDS" ? "WINNING_ODDS" : usr._id.bt)}_${usr._id.et}`)].pnl += Math.round(usr.pnl) ;
               if(usr.commission !== 0){
                  mySharingUserMappedList[usr._id.username][`TOTALCOM_${usr._id.et}`].commission += usr.commission ;
               }
               mySharingUserMappedList[usr._id.username][`TOTAL_${usr._id.et}`].total += (Math.round(usr.pnl) + usr.commission);
               mySharingUserMappedList[usr._id.username][`TOTAL_${usr._id.et}`].bets += usr.bets ;
               mySharingUserMappedList[usr._id.username][`TOTAL_PNL`] += (Math.round(usr.pnl) + usr.commission);
               mySharingUserMappedList[usr._id.username][`MYSHARE`] = -((mySharingUserMappedList[usr._id.username][`TOTAL_PNL`] * mySharingUserMappedList[usr._id.username][`SHARINGPERCENT`])/100);
            }
            this.setState({ mySharingUserMappedList: mySharingUserMappedList, isMySharingUserMappedList: Object.keys(mySharingUserMappedList).length > 0 ? true: false, showData: true, loader: false })
            
         } else {
            this.props.notify(res.message, "error")
            this.setState({ mySharingUserMappedList:{}, totalnew:0, isMySharingUserMappedList: false, showData: true, loader: false })
         }
         
         this.setState({ user_list: Object.values(this.state.mySharingUserMappedList) })
      })
   }

   async onDownload(user_list_data, alldata = false) {
      let linkClick
      const self = this;
      this.setState({ csv_json: [] }, () => {
         // let list = Object.values(this.state.mySharingUserMappedList)
         let items = []
         let i = 0
         for (let x of user_list_data) {
            if (alldata ? true : (i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)))){ 
               let dictinory = {}
               dictinory["User"] = x["USER"]
               dictinory["Distributor"] = x["PARENT"]

               dictinory["Cricket MATCH ODDS"] = x["ODDS_4"].pnl
               dictinory["Cricket BOOKMAKER"] = x["BOOKMAKER_4"].pnl
               dictinory["Cricket FANCY"] = x["FANCY_4"].pnl
               dictinory["Cricket LINE"] = x["LINE_4"].pnl
               dictinory["Cricket LOTTERY"] = x["WINNING_ODDS_4"].pnl
               dictinory["Cricket Commission"] = x["TOTALCOM_4"].commission.toFixed(2)
               dictinory["Cricket Total"] = x["TOTAL_4"].total.toFixed(2)
               dictinory["Cricket Bets"] = x["TOTAL_4"].bets

               dictinory["Soccer MATCH ODDS"] = x["ODDS_1"].pnl
               dictinory["Soccer BOOKMAKER"] = x["BOOKMAKER_1"].pnl
               dictinory["Soccer OVER UNDER"] = x["OVER_UNDER_1"].pnl
               dictinory["Cricket LOTTERY"] = x["WINNING_ODDS_1"].pnl
               dictinory["Soccer Commission"] = x["TOTALCOM_1"].commission.toFixed(2)
               dictinory["Soccer Total"] = x["TOTAL_1"].total.toFixed(2)
               dictinory["Soccer Bets"] = x["TOTAL_1"].bets

               dictinory["Tennis MATCH ODDS"] = x["ODDS_2"].pnl
               dictinory["Tennis BOOKMAKER"] = x["BOOKMAKER_2"].pnl
               dictinory["Cricket LOTTERY"] = x["WINNING_ODDS_2"].pnl
               dictinory["Tennis Commission"] = x["TOTALCOM_2"].commission.toFixed(2)
               dictinory["Tennis Total"] = x["TOTAL_2"].total.toFixed(2)
               dictinory["Tennis Bets"] = x["TOTAL_2"].bets

               dictinory["Horse WIN"] = x["ODDS_7"].pnl
               dictinory["Horse Commission"] = x["TOTALCOM_7"].commission.toFixed(2)
               dictinory["Horse Total"] = x["TOTAL_7"].total.toFixed(2)
               dictinory["Horse Bets"] = x["TOTAL_7"].bets

               dictinory["GreyHound WIN"] = x["ODDS_4339"].pnl
               dictinory["GreyHound Commission"] = x["TOTALCOM_4339"].commission.toFixed(2)
               dictinory["GreyHound Total"] = x["TOTAL_4339"].total.toFixed(2)
               dictinory["GreyHound Bets"] = x["TOTAL_4339"].bets

               dictinory["Kabaddi BOOKMAKER"] = x["BOOKMAKER_400"].pnl
               dictinory["Kabaddi FANCY"] = x["FANCY_400"].pnl
               dictinory["Cricket LOTTERY"] = x["WINNING_ODDS_400"].pnl
               dictinory["Kabaddi Total"] = x["TOTAL_400"].total.toFixed(2)
               dictinory["Kabaddi Bets"] = x["TOTAL_400"].bets
               
               dictinory["Total P&L"] = x["TOTAL_PNL"]
               dictinory["My Share"] = x["MYSHARE"]
              
              
               items.push(dictinory)
            }
            i += 1
         }
         this.setState({ csv_json: items }, () => {
            linkClick = setTimeout(function () {
               self.csvLink.current.link.click();
            }, 500)
         })
      })

   }

   sortShare(fild, shortType) {
      this.setState({ shortField: fild, shortType: shortType })
   }
   onSearch(e) {
      // let userList = Object.keys(this.state.mySharingUserMappedList)
      this.setState({ searchText: e.target.value, pageActive: 1 }, () => {
         // this.setState({ user_list: userList })
      })
   }
   filterUserData(userArray) {
      let userList = userArray;
      let self = this
      if (this.state.searchText !== "" || this.state.searchText !== null || this.state.searchText !== undefined) {
         userList = _.filter(userList, function (obj) {
            return ( obj['USER'].toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1 || obj['PARENT'].toLowerCase().indexOf(self.state.searchText.toLowerCase()) !== -1);
         });
      }
      return Object.assign([], userList)
   }

   applySort(userArray) {
      let userList = userArray
      if(this.state.shortField === 'USER'){
         if(this.state.shortType === 'asc'){
            userList.sort((userA, userB) => {
               return userA[this.state.shortField].localeCompare(userB[this.state.shortField]);
            });
         } else { 
            userList.sort((userA, userB) => {
               return userB[this.state.shortField].localeCompare(userA[this.state.shortField]);
            })
         } 
      } else {

         if(this.state.shortType === 'asc'){
            userList.sort((userA, userB) => {
               return userB[this.state.shortField] - userA[this.state.shortField];
            });
         } else {
            userList.sort((userA, userB) => {
               return userA[this.state.shortField] - userB[this.state.shortField];
            });
         }
      }
     return userList;
   }

   clean(obj) {
      for (var propName in obj) {
         if (obj[propName] === undefined) {
            delete obj[propName];
         }
      }
      return obj
   }
   resetForm() {
      let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
      this.setState({ from: weekDate, to: curDate, client_id: "", usersList: [], isMySharingUserMappedList: false, showData: false, mySharingUserMappedList: {}, totalnew:0, user_list: [] })
   }
   onSubmit(e) {
      let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 31) {
         this.props.notify("Date range must be 1 month.", "error")
      }
      else {
         this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
      }
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   onDateTimeChange(name, e) {
      this.setState({ [name]: e._d, isMySharingUserMappedList: false, showData: false, mySharingUserMappedList: {}, totalnew:0 })
   }
   async onUserSearch(e, name, value) {
      if (value.length > 1) {
         this.setState({ [name]: value })
         let res = await userService.getUserSearch(this.state.accounts, value)
         let lst = []
         for (let x of res.usersList) {
            lst.push({ label: x, value: x, title: x, name: x })
         }
         lst.sort(function(a, b) {
             if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
             if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
             return 0;
         });
         this.setState({ usersList: lst })
      }
      else {
         this.setState({ [name]: value, usersList: [] })
      }
   }


   onAction(e) {
      const name = e.target.name;
      if (name === "first") {
         this.setState({ pageActive: 1 })
      } else if (name === "prev") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive - 1) }) ) 
      } else if (name === "next") {
         this.setState({ action: name }, this.setState({ pageActive: (this.state.pageActive + 1) }) )
      } else if (name === "last") {
         this.setState({ action: name }, this.setState({ pageActive: Math.ceil(Object.keys(this.state.mySharingUserMappedList).length / this.state.pageLimit)}) ) 
      } 
   }

   render() {
      let userList = Object.assign([], this.filterUserData(this.state.user_list)) 
          userList = Object.assign([], this.applySort(userList)) 
          
      let lst = []
      let total_page = Math.ceil(userList.length/ this.state.pageLimit)
      for (let x = 1; x <= total_page; x++) {
         if (this.state.pageActive === x || Math.abs(x - this.state.pageActive) <= 2 || (this.state.pageActive < 3 && x < 6) || (total_page - this.state.pageActive < 3 && total_page - x < 5)) {
            let htm = <button className={this.state.pageActive === x ? "btn btn-blue active pagewidth" : "btn btn-blue pagewidth"} key={"unsettle_btn_" + (x)} name="page_no" value={x} onClick={(e) => {{ this.onAction(e) } this.setState({ pageActive: x })}}>{x} </button>
            lst.push(htm)
         }
      }


      return (
         <div className="bethubs">
            <Header history = {this.props.history} />
            <div className="wrapper">
               <div className="container-fluid container-padding-0">
                  <div className="row">
                     <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="main-box">
                           <h5 className="text-blue">Sports Revenue</h5>
                           <div className="row mx-0">
                              {/* <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                 <div className="form-group font-12 autocomplete-wrapper">
                                    <Autocomplete
                                       value={this.state.client_id}
                                       items={this.state.usersList}
                                       getItemValue={item => item.title}
                                       renderItem={(item, isHighlighted) =>
                                          <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                             {item.title}
                                          </div>
                                       }
                                       inputProps={{ placeholder: 'Search by client' }}
                                       name="client_id"
                                       onChange={(event, client_id) => this.onUserSearch(event, "client_id", client_id)}
                                       onSelect={client_id => this.setState({ client_id })}
                                    />
                                 </div>
                              </div> */}
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="form-group font-12">
                                    <Datetime
                                       value={this.state.from}
                                       onChange={(e) => this.onDateTimeChange("from", e)}
                                       id="from_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="form-group font-12">
                                    <Datetime
                                       value={this.state.to}
                                       onChange={(e) => this.onDateTimeChange("to", e)}
                                       id="to_datetime"
                                       dateFormat={"DD/MM/YYYY"}
                                       timeFormat={"HH:mm"}
                                    />
                                 </div>
                              </div>
                              <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 mb-2">
                                 <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                    <button className="btn btn-blue" disabled={!!this.state.from && !!this.state.to ? false : true} onClick={(e) => this.onSubmit(e)}>Go</button>
                                    <button className="btn btn-blue ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                 </div>
                              </div>
                           </div>
                           {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}>Loading......</div> : null}
                           {!!this.state.showData && <div>
                              
                              <div className="row text-center mt-2">
                                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 my-1">
                                    <div className="d-flex float-left">
                                       <div className="form-group mb-0 d-inline">
                                           <input className="form-control  d-inline-block" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" disabled={!!this.state.select_downline_user_id ? true : false} value={this.state.searchText}/>
                                        </div>
                                       <CSVLink
                                          data={this.state.csv_json}
                                          filename={"Sports Revenue.csv"}
                                          asyncOnClick={true}
                                          className="d-none"
                                          ref={this.csvLink}>
                                       </CSVLink>
                                       <button className="btn btn-sm d-inline csv-icon p-0" title="Export Data" onClick={(e) => this.onDownload(userList)} disabled={userList.length > 0 ? false : true}><img alt="" src={`${BASE_IMAGE_PATH_NEW}/casino/banner/images/csv-icon.svg`}></img></button>
                                       <button className="btn btn-sm d-inline csv-icon-all p-0" title="Export All Data" onClick={(e) => this.onDownload(this.state.user_list, true)} disabled={userList.length > 0 ? false : true}><img alt="" src={BASE_IMAGE_PATH_NEW + "/casino/banner/images/csv-icon-all.svg"}></img></button>
                                                      
                                      </div>
                                    </div>
                                     <div className="col-6 col-sm-6 col-md-6 col-lg-6">
                                          <span className="d-inline search-report"> &nbsp; entries</span>
                                          <div className="form-group font-12 float-right mb-0">
                                             <select onKeyPress={(e) => this.onAction(e)} onChange={(e) => { this.onChange(e) }} className="form-control" name="pageLimit" value={this.state.pageLimit}>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                                <option value="500">500</option>
                                             </select>
                                           </div>
                                           <span className="d-inline search-report mr-2">Show</span>
                                     </div>
                              </div>

                              <div id="printJS-div" className="table-responsive">
                                 <table id="example" className="table table-striped table-bordered table-sm addpadding nowrap w-100">
                                    <thead>
                                    <tr>
                                          <th className="wid165 pthead"></th>
                                          <th className="pthead"></th>
                                          <th className="pthead text-center" colSpan={8}>Cricket</th>
                                          <th className="pthead text-center" colSpan={7}>Soccer</th>
                                          <th className="pthead text-center" colSpan={6}>Tennis</th>
                                          <th className="pthead text-center" colSpan={4}>Horse</th>
                                          <th className="pthead text-center" colSpan={4}>GreyHound</th>
                                          <th className="pthead text-center" colSpan={5}>Kabaddi</th>
                                          <th className="pthead"></th>
                                          <th className="pthead"></th>
                                       </tr>
                                       <tr>
                                          <th className="wid165 pthead">User 
                                          <span className="d-contant" style={{ float: "right" }}>
                                                   <span onClick={() => { this.sortShare("USER", "asc") }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                   <span onClick={() => { this.sortShare("USER", "dasc") }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                          </span>
                                          </th>
                                          <th className="pthead">Distributor <span className='v-hide'>Parent Hide</span></th>
                                          <th className="pthead text-right">MATCH&nbsp;ODDS</th>
                                          <th className="pthead text-right">BOOKMAKER</th>
                                          <th className="pthead text-right">FANCY</th>
                                          <th className="pthead text-right">LINE</th>
                                          <th className="pthead text-right">LOTTERY</th>
                                          <th className="pthead text-right">Commission</th>
                                          <th className="pthead text-right">Total</th>
                                          <th className="pthead text-right">Bets</th>
                                          <th className="pthead text-right">MATCH&nbsp;ODDS</th>
                                          <th className="pthead text-right">BOOKMAKER</th>
                                          <th className="pthead text-right">OVER&nbsp;UNDER</th>
                                          <th className="pthead text-right">LOTTERY</th>
                                          <th className="pthead text-right">Commission</th>
                                          <th className="pthead text-right">Total</th>
                                          <th className="pthead text-right">Bets</th>
                                          <th className="pthead text-right">MATCH&nbsp;ODDS</th>
                                          <th className="pthead text-right">BOOKMAKER</th>
                                          <th className="pthead text-right">LOTTERY</th>
                                          <th className="pthead text-right">Commission</th>
                                          <th className="pthead text-right">Total</th>
                                          <th className="pthead text-right">Bets</th>
                                          <th className="pthead text-right">WIN</th>
                                          <th className="pthead text-right">Commission</th>
                                          <th className="pthead text-right">Total</th>
                                          <th className="pthead text-right">Bets</th>
                                          <th className="pthead text-right">WIN</th>
                                          <th className="pthead text-right">Commission</th>
                                          <th className="pthead text-right">Total</th>
                                          <th className="pthead text-right">Bets</th>
                                          <th className="pthead text-right">BOOKMAKER</th>
                                          <th className="pthead text-right">FANCY</th>
                                          <th className="pthead text-right">LOTTERY</th>
                                          <th className="pthead text-right">Total</th>
                                          <th className="pthead text-right">Bets</th>
                                          <th className="pthead text-right">Total&nbsp;P&L</th>
                                          <th className="pthead text-right">My&nbsp;share
                                          <span className="d-contant" style={{ float: "right" }}>
                                                   <span onClick={() => { this.sortShare("MYSHARE", "asc") }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↑</span>
                                                   <span onClick={() => { this.sortShare("MYSHARE", "dasc") }} style={{ fontSize: "11px", padding: "0px 0px 0px 3px", cursor: "pointer", fontWeight: "1000" }}>↓</span>
                                          </span>
                                          </th>
                                       </tr>
                                    </thead>
                                    <tbody id="tblAccountStatement">
                                       {!!this.state.loader ?
                                          <tr>
                                             <td colSpan={21} className="text-center py-5">
                                                <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                             </td>
                                          </tr> : this.state.isMySharingUserMappedList ? <>
                                             {userList.length > 0 && userList.map((usrsh, i) => {
                                                const usrshr = usrsh;//this.state.mySharingUserMappedList[usrsh]
                                                return (<>  
                                                   {i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) &&
                                                      <tr key={i}>
                                                         <td>{usrshr['USER']}</td>
                                                         {/* <td>{usrshr['PARENT']}</td> */}
                                                         <td><span className={usrshr['PARENTROLE'] === "SuperMaster" || usrshr['PARENTROLE'] === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + usrshr['PARENTROLE'] + "-icon.svg"} alt="" /></span><span>{usrshr['PARENT']}</span></td>

                                                         <td className="text-right fbold">{usrshr['ODDS_4'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['BOOKMAKER_4'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['FANCY_4'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['LINE_4'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['WINNING_ODDS_4'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['TOTALCOM_4'].commission.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_4'].total.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_4'].bets}</td>

                                                         <td className="text-right fbold">{usrshr['ODDS_1'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['BOOKMAKER_1'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['OVER_UNDER_1'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['WINNING_ODDS_1'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['TOTALCOM_1'].commission.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_1'].total.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_1'].bets}</td>

                                                         <td className="text-right fbold">{usrshr['ODDS_2'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['BOOKMAKER_2'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['WINNING_ODDS_2'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['TOTALCOM_2'].commission.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_2'].total.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_2'].bets}</td>

                                                         <td className="text-right fbold">{usrshr['ODDS_7'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['TOTALCOM_7'].commission.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_7'].total.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_7'].bets}</td>

                                                         <td className="text-right fbold">{usrshr['ODDS_4339'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['TOTALCOM_4339'].commission.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_4339'].total.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_4339'].bets}</td>

                                                         <td className="text-right fbold">{usrshr['BOOKMAKER_400'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['FANCY_400'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['WINNING_ODDS_400'].pnl}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_400'].total.toFixed(2)}</td>
                                                         <td className="text-right fbold">{usrshr['TOTAL_400'].bets}</td>

                                                         <td className="text-right fbold">{usrshr['TOTAL_PNL'].toFixed(2)}</td>
                                                         <td className={`text-right fbold ${usrshr['MYSHARE'] < 0 ? 'text-danger' : 'text-success' }`} title={`Sharing percent = ${usrshr['SHARINGPERCENT']}`}>{usrshr['MYSHARE'].toFixed(2)}</td>
                                                      </tr> 
                                                   }
                                                </>);
                                             })
                                             }
                                             {/* {!!this.state.totalnew &&
                                                <tr>
                                                   <td colSpan={2} className="fbold">Total</td>
                                                   <td className="text-right fbold"><Currency key={"pnl_total"} className={this.state.totalpnl > 0 ? "text-right text-success fbold" : this.state.totalpnl < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalpnl ? this.state.totalpnl : 0} showColor={false} /></td>
                                                   <td className="text-right fbold"><Currency key={"commission_total"} className={this.state.totalcommission > 0 ? "text-right text-success fbold" : this.state.totalcommission < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalcommission ? this.state.totalcommission : 0} showColor={false} /></td>
                                                   <td className="text-right fbold"><Currency key={"pnl_commission_total"} className={this.state.totalnew > 0 ? "text-right text-success fbold" : this.state.totalnew < 0 ? "text-right text-danger fbold" : "text-right text-dark fbold"} amount={!!this.state.totalnew ? this.state.totalnew : 0} showColor={false} /></td>
                                                </tr>} */}
                                          </>
                                             :
                                             <tr>
                                                <td colSpan={34} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Data Found</h5></td>
                                             </tr>
                                       }
                                    </tbody>
                                 </table>
                              </div>


                           </div>}
                          

                           { 
                              userList.length > 0 &&
                              <>       
                                 <div className="row">
                                    <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) < userList.length ? (this.state.pageLimit * this.state.pageActive) : userList.length} of {userList.length} entries</span></div>
                                    <div className="col-12 col-sm-12 col-md-6">
                                       <div className="btn-group float-right" role="group" aria-label="Basic example" id="pagination-btn">
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="first" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>First</button>
                                          <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === 1 ? true : false}>Prev</button>
                                          {lst}  
                                          <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(userList.length / this.state.pageLimit)? true : false}>Next</button>
                                          <button type="button" className="btn btn-blue" id="NextPage" name="last" onClick={(e) => this.onAction(e)} disabled={this.state.pageActive === Math.ceil(userList.length / this.state.pageLimit)? true : false}>Last</button>
                                       </div>
                                    </div>
                                 </div>
                              </>
                           }

                           {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} /> }
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <Footer />
         </div>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(SportsRevenue);